import styled from 'styled-components';
import { socialMedia } from '../../../contants';
import LinkButton from '../../LinkButton/LinkButton';

const SocialMediaTile = ({ value = '' }) => {
  const { logo, url } = socialMedia[value];

  return (
    <Wrapper>
      <Logo alt='Missing logo' src={logo} />
      <LinkWrapper>
        <a href={url}>
          <LinkButton id={value} />
        </a>
      </LinkWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  height: 100%;
`;

const Logo = styled.img`
  position: absolute;
  object-fit: cover;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 30px;
`;

const LinkWrapper = styled.div`
  position: absolute;
  bottom: 14px;
  left: 14px;
`;

export default SocialMediaTile;
